import { render, staticRenderFns } from "./MedicalHospitals.vue?vue&type=template&id=58609d78&scoped=true"
import script from "./MedicalHospitals.vue?vue&type=script&lang=js"
export * from "./MedicalHospitals.vue?vue&type=script&lang=js"
import style0 from "./MedicalHospitals.vue?vue&type=style&index=0&id=58609d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58609d78",
  null
  
)

export default component.exports